<template>
    <div class="comp-header-dc comp">
        <div class="header-top">
            <div class="header-top-container">
                <div>
                    <span>{{ $const.COMPANY }}财富</span>
                    <span class="line">理财热线 {{ $cache.getCompanyInfoParam("10101009") }}</span>
                </div>
                <div class="flex">
                    <span v-if="login">
                        {{
                            info.custname
                                ? info.custname
                                : $util.desensitizePhoneNumber(info.mobile)
                                ? $util.desensitizePhoneNumber(info.mobile)
                                : $util.desensitizePhoneNumber(info.mobileno)
                        }}
                    </span>
                    <!-- <span v-if="info.risklevel && login" class="line">
                        风险等级：{{
                            "C" +
                            info.risklevel +
                            "(" +
                            $cache.getDict("140011", info.risklevel).replace("承受能力", "") +
                            ")"
                        }}
                    </span> -->
                    <span v-if="otherInfo.lucre && login" class="line">
                        积分：{{ otherInfo.lucre }}
                    </span>
                    <span v-if="!login" v-on:click.stop="$util.goToHxLogin()">登录/开户</span>
                    <!--                    <span class="service cursor line">-->
                    <!--                        <img :src="require('../../assets/img/service.png')" />-->
                    <!--                        <span>在线客服</span>-->
                    <!--                    </span>-->
                    <span v-if="login" class="logoff cursor line" v-on:click.prevent="logoff">
                        <img :src="require('../../assets/img/logoff.png')" />
                        <span>[安全退出]</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="header-box">
                <div class="logo">
                    <a :href="$cache.getCompanyInfoParam('10101006')" target="_blank">
                        <img
                            v-if="$cache.getCompanyInfoParam('10101007')"
                            :src="
                                $util.imgSrc({
                                    fileCode: $cache.getCompanyInfoParam('10101007')
                                })
                            "
                            height="36"
                            alt=""
                        />
                    </a>
                    <span v-if="tit" class="tit">{{ tit }}</span>
                </div>
                <ul v-if="!login" class="links">
                    <slot></slot>
                </ul>
                <div v-else class="menu right">
                    <menu-con v-if="!menuHidden" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import userApi from "@/api/user";
import menuCon from "@/components/frame/menu.vue";
export default {
    name: "HeaderComDc",
    components: {
        menuCon
    },
    props: {
        tit: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            info: {},
            otherInfo: {},
            login: false,
            menuHidden: false
        };
    },
    watch: {
        "$store.state.user.info": {
            handler() {
                this.initData();
            },
            deep: true
        }
    },
    mounted() {
        document.title = this.$cache.getCompanyInfoParam("10101001") || this.$route.meta.nameText;
        this.menuHidden = this.$route.meta.menuHidden;
        this.initData();
    },
    methods: {
        initData() {
            this.info = this.$cache.getUser();
            this.login = this.$store.state.login.status;
        },
        async qryCrmCustInfo() {
            const otherUserInfo = this.$cache.getUserOtherInfo();
            if (otherUserInfo && otherUserInfo.custnoCrm) {
                const res = await userApi.qryCrmCustInfo({
                    custnoCrm: otherUserInfo.custnoCrm
                });
                this.otherInfo = res.data;
            }
        },
        async logoff() {
            const res = await userApi.logout();
            if (res.error) return;
            this.$store.dispatch("logout", res.data).then(() => {
                window.location.href = `${
                    this.$util.getConfig().hxUrl.wechatLogout
                }${encodeURIComponent(this.$cache.getCompanyInfoParam("10101006"))}`;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.comp-header-dc {
    background-color: $bg2;
    min-width: 1200px;
    border-bottom: 3px solid $color-a;
    .header-top {
        background: $bg1;
        font-size: 14px;
        color: $text-color1;
        .header-top-container {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 1200px;
            margin: 0 auto;
        }
        .service,
        .logoff {
            color: $bg18;
            display: flex;
            align-items: center;
            img {
                width: 16px;
                height: 16px;
                margin-right: 6px;
            }
        }
        .logoff img {
            width: 13.5px;
            height: 13.5px;
        }
        span {
            display: inline-block;
        }
        .line {
            position: relative;
            &:before {
                content: "";
                height: 17px;
                margin: 0 10px;
                border-left: 1px solid #666666;
            }
        }
    }
    .container {
        position: relative;
        height: 100%;
        .header-box {
            height: 80px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .logo {
            margin-top: 0;
            display: inline-block;
            display: flex;
            align-items: center;
            .tit {
                display: inline-block;
                color: $text-color2;
                font-size: $f22;
                min-width: 200px;
                font-weight: 500;
            }
            .tit:before {
                content: "";
                margin: 0 24px 0 34px;
                border-left: 1px solid #ccc;
            }
            img {
                vertical-align: middle;
                height: 36px;
            }
        }
        .menu {
            outline: none;
        }
        .links {
            font-size: 14px;
            color: $text-color1;
            li {
                display: inline-block;
                margin-left: 12px;
            }
        }
    }
}
</style>
